(function () {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('VaccineController', VaccineController);

    VaccineController.$inject = ['$scope', '$state', 'Vaccine', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function VaccineController($scope, $state, Vaccine, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile) {
        var vm = this;
        vm.title = 'Vaccines';
        vm.entityClassHumanized = 'Vaccines';
        vm.entityStateName = 'vaccine';

        vm.vaccines = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                Vaccine.query(function (result) {
                    vm.vaccines = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.vaccines, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function loadAll() {
            Vaccine.query(function (result) {
                vm.vaccines = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['all']);
        }

        function search() {
            vm.dtInstance.reloadData();
        }

    }
})();
